(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq-item"] && !Shopify.designMode) return;
  try {
    class FaqItemAccordion extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.faq-item__answer-wrapper');
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      event.preventDefault();
      this.details.style.overflow = 'hidden';

      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) this.animation.cancel();

      this.animation = this.details.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'ease-out' }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => {
        this.isClosing = false;
      };
    }

    open() {
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) this.animation.cancel();

      this.animation = this.details.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'ease-out' }
      );

      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => {
        this.isExpanding = false;
      };
    }

    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.style.height = '';
      this.details.style.overflow = '';
    }
  }

  customElements.define('faq-item-accordion', FaqItemAccordion);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    const CONSENT_RETRY_MS = 5000;
  const CONSENT_MAX_WAIT_MS = 60000;
  const CONSENT_CLOSE_PAUSE_MS = 600;

  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.storageKey = 'ballzi:newsletter-popup-dismissed';

      this.querySelector('.newsletter-popup__close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => this.remember());

      if (this.querySelector('.newsletter-popup__success')) {
        this.remember();
        this.dialog.showModal();
        return;
      }

      if (this.wasDismissed() || this.dataset.suppressed === 'true') return;

      this.delayMs = Number(this.dataset.delayMs) || 20000;
      this.schedule(this.delayMs);

      // Note early whether the cookie banner is on screen, so a choice made
      // before the popup is due is recognised as "banner seen, then gone".
      this.onConsentSeen = () => { this.bannerSeen = true; };
      document.addEventListener('visitorConsentCollected', this.onConsentSeen);
      this.consentProbeId = window.setTimeout(() => this.consentBannerState(), 1500);

      // Never interrupt a purchase: an add-to-cart pushes the popup back.
      this.onCartUpdated = () => this.schedule(this.delayMs);
      document.addEventListener('ballzi:cart:updated', this.onCartUpdated);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timeoutId);
      window.clearTimeout(this.consentProbeId);
      if (this.onConsentSeen) document.removeEventListener('visitorConsentCollected', this.onConsentSeen);
      if (this.onCartUpdated) document.removeEventListener('ballzi:cart:updated', this.onCartUpdated);
      if (this.onConsentCollected) document.removeEventListener('visitorConsentCollected', this.onConsentCollected);
    }

    schedule(delayMs) {
      window.clearTimeout(this.timeoutId);
      this.waitingForConsent = false;
      this.unknownSince = null;
      this.timeoutId = window.setTimeout(() => this.tryOpen(delayMs), delayMs);
    }

    tryOpen(delayMs) {
      if (document.querySelector('dialog[open]')) {
        this.schedule(delayMs);
        return;
      }

      const state = this.consentBannerState();

      // Never stack on top of the cookie banner: wait for the visitor's
      // choice (visitorConsentCollected), re-checking every 5 s as a safety net.
      if (state === 'visible') {
        this.unknownSince = null;
        this.waitForConsent(delayMs, CONSENT_RETRY_MS);
        return;
      }

      // Banner state cannot be determined (consent script blocked or not loaded
      // yet): retry every 5 s for 60 s at most, then show anyway so a content
      // blocker can never hide the popup for good. Consent is never read or
      // written here, only the banner's presence is observed.
      if (state === 'unknown') {
        const now = Date.now();
        if (this.unknownSince === null) this.unknownSince = now;
        if (now - this.unknownSince < CONSENT_MAX_WAIT_MS) {
          this.waitForConsent(delayMs, CONSENT_RETRY_MS);
          return;
        }
      }

      this.waitingForConsent = false;
      this.unknownSince = null;
      this.dialog.showModal();
    }

    waitForConsent(delayMs, retryMs) {
      this.waitingForConsent = true;
      window.clearTimeout(this.timeoutId);
      this.timeoutId = window.setTimeout(() => this.tryOpen(delayMs), retryMs);

      if (!this.onConsentCollected) {
        // Official Shopify event, fired once the visitor accepts or declines.
        // A short pause lets the banner finish disappearing before we open.
        this.onConsentCollected = () => {
          if (!this.waitingForConsent) return;
          window.clearTimeout(this.timeoutId);
          this.timeoutId = window.setTimeout(() => this.tryOpen(this.delayMs), CONSENT_CLOSE_PAUSE_MS);
        };
        document.addEventListener('visitorConsentCollected', this.onConsentCollected);
      }
    }

    // 'visible': the cookie banner is on screen. 'clear': no banner to show.
    // 'unknown': cannot tell (no banner in the DOM and no usable privacy API).
    consentBannerState() {
      const banner = document.getElementById('shopify-pc__banner');
      if (banner && banner.getClientRects().length > 0 && window.getComputedStyle(banner).visibility !== 'hidden') {
        this.bannerSeen = true;
        return 'visible';
      }

      // The banner was on screen and is gone: the visitor has made a choice,
      // so there is nothing left to wait for (the privacy API does not always
      // answer once the banner is closed).
      if (this.bannerSeen) return 'clear';

      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.shouldShowBanner === 'function') {
        try {
          // The banner is expected but not rendered yet: treat as undetermined
          // so the 60 s cap applies if it never shows up.
          return privacy.shouldShowBanner() ? 'unknown' : 'clear';
        } catch (error) {
          return 'unknown';
        }
      }

      return 'unknown';
    }

    wasDismissed() {
      try {
        return window.localStorage.getItem(this.storageKey) === 'true';
      } catch (error) {
        return false;
      }
    }

    remember() {
      try {
        window.localStorage.setItem(this.storageKey, 'true');
      } catch (error) {
        // Storage unavailable (private browsing, blocked cookies): the
        // popup may show again next visit, which is an acceptable fallback.
      }
    }
  }

  customElements.define('newsletter-popup', NewsletterPopup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-upsell-popup"] && !Shopify.designMode) return;
  try {
    class ProductUpsellPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.closeButton = this.querySelector('.product-upsell-popup__close');
      this.closeButton.addEventListener('click', () => this.dialog.close());
      const delayMs = Number(this.dataset.delayMs) || 4000;
      this.timeoutId = window.setTimeout(() => this.dialog.showModal(), delayMs);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timeoutId);
    }
  }

  customElements.define('product-upsell-popup', ProductUpsellPopup);
  } catch(e) { console.error(e); }
})();

})();
